import { Injector } from "@angular/core";
import { GridActionHandlerBase } from "../../../../../../components/common/grid-base/actions/grid-action-handler-base";
import { WorkspaceBase } from "../../../../../../components/common/workspace-base/workspace-base";
import { ReportsWorkspaceComponent } from "../reports-workspace.component";

/**
 * Sync report with argus
 */
export class SyncWithArgusGridActionHandler extends GridActionHandlerBase {
  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   * @param topic Topic (subscribeEvent topic)
   */
  constructor(injector: Injector, workspace: WorkspaceBase) {
    super(injector, workspace, 'buttonSyncReportWithArgus');
  }

  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void {
    const oids = this.workspace.grid.getFlattenGridDataResultData().filter(item => item.checkbox === true).map(item => item.Oid);

    if (oids.length === 0) {
      this.eventBus.broadcastEvent("openConfirmDialog", {
        success: () => {
          //Nothing
        }
      }, 'errorMessageChooseReport');
    } else {
      const workspace = this.workspace as ReportsWorkspaceComponent;
      workspace.selectedReports = oids;
      workspace.showArgusSyncDialog = true;
    }
  }
}
